import React, { Component } from "react";
import _ from "lodash";
import { Table, Image } from "semantic-ui-react";
import getPersonName from "../../common/Name";
import { getDobDate } from "../../common/DisplayDate";

class PhysicalDescNimbus extends Component {
  componentDidMount() { }

  render() {
    const node = this.props.node;
    const physicalData = `${_.get(node, "ethnicity[0]._", "")} ${_.get(
      node,
      "gender[0]._",
      ""
    )} ${_.get(node, "weight[0]._", "")} ${_.get(node, "height[0]._", "")}`;
    const dob = _.get(this.props.node, "DOB[0]");
    let dobValue = getDobDate(dob, { userAccount: this.props.userAccount });
    let hairEye = "";
    if (dob === undefined) {
      dobValue = getDobDate(_.get(this.props.node, "otherDOBs[0].DOB[0]._", ""), {
        userAccount: this.props.userAccount,
        isDobValue: true,
      });
      hairEye = `${_.get(node, "haircolor[0]._", "")} ${_.get(
        node,
        "eyecolor[0]._",
        ""
      )}`;
    } else {
      hairEye = `${_.get(node, "hair[0]._", "")} ${_.get(
        node,
        "eyes[0]._",
        ""
      )}`;
    }

    const photoPath = _.get(node, "photoName[0]._", "");
    const comments = _.get(node, "comments[0]._", "");

    return (
      <Table>
        <Table.Body>
          <Table.Row className="report-sub-section-header">
            <Table.HeaderCell colSpan={photoPath !== "" ? 5 : 4}>
              Physical Description
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className="text-bold">NAME:</Table.Cell>
            <Table.Cell>
              {getPersonName(
                _.get(node, "name[0].firstName[0]._", ""),
                _.get(node, "name[0].middleName[0]._", ""),
                _.get(node, "name[0].lastName[0]._", ""),
                this.props
              )}
            </Table.Cell>
            <Table.Cell className="text-bold">DATE OF BIRTH:</Table.Cell>
            <Table.Cell>{dobValue}</Table.Cell>
            {photoPath !== "" ? (
              <Table.Cell rowSpan={comments === "" ? 2 : 3} width={2}>
                <Image src={photoPath} className={"display-photo"} />
              </Table.Cell>
            ) : null}
          </Table.Row>
          <Table.Row>
            <Table.Cell className="text-bold">PHYSICAL DATA:</Table.Cell>
            <Table.Cell>{physicalData}</Table.Cell>
            <Table.Cell className="text-bold">HAIR/EYE COLOR:</Table.Cell>
            <Table.Cell>{hairEye}</Table.Cell>
          </Table.Row>
          {comments === "" ? null : (
            <Table.Row>
              <Table.Cell colSpan={photoPath !== "" ? 4 : 3}>
                {comments}
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    );
  }
}

export default PhysicalDescNimbus;



// WEBPACK FOOTER //
// ./src/components/reports/Criminal/PhysicalDescNimbus.js